import { render, staticRenderFns } from "./colorMenu.vue?vue&type=template&id=5bd1d9fe&"
import script from "./colorMenu.vue?vue&type=script&lang=js&"
export * from "./colorMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports